import { FormikStringSchema, useClearOnUnmount, useFieldHelpers } from '@/base'
import { Select, SelectProps } from '../../atoms/select'
import { FormField, FormFieldProps } from '.'

export const FormSelect = <T extends boolean | number | string>(
  props: Omit<SelectProps<T>, 'onChange' | 'value'> &
    Omit<FormFieldProps, 'children'> & {
      onChange?: (val: T | undefined) => void
      schema?: FormikStringSchema
      shouldClearOnDismount?: boolean
      wrapperClassName?: string
      placeholder?: string
    } & React.HTMLAttributes<HTMLDivElement>
) => {
  const {
    name,
    label,
    schema,
    message,
    description,
    optionalText,
    onChange,
    shouldClearOnDismount,
    placeholder,
  } = props
  const { field, helpers } = useFieldHelpers({ name, schema })
  useClearOnUnmount(shouldClearOnDismount, helpers.setValue)
  return (
    <FormField
      name={name}
      label={label}
      schema={schema}
      message={message}
      description={description}
      optionalText={optionalText}
    >
      <Select
        placeholder={
          (typeof label === 'string' && label) || placeholder || undefined
        }
        data-testid={`dropdown-${name}`}
        {...props}
        {...field}
        onBlur={() => helpers.setTouched(true)}
        onValueChange={(val: T | undefined) => {
          onChange?.(val)
          return helpers.setValue(val)
        }}
      />
    </FormField>
  )
}
